module.exports = __webpack_public_path__ + "static/img1-8a59cfc562a7490d7b157101ad538a5a.jpg";